import { call, put, takeEvery, select, fork } from "redux-saga/effects"
import { toast } from "react-toastify"
// Crypto Redux States
import CompanyTypes from "./actionTypes"
import CompanyAPI from "helpers/company_backend_helper"
import CompanyAction from "./actions"

function* fetchCompanyListOnPage({ payload }) {
  yield put(
    CompanyAction.getListPagesSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    const currentPage = payload.page
    let { data } = yield call(CompanyAPI.getListPage, {
      ...payload,
      page: currentPage,
    })
    yield put(
      CompanyAction.getListPagesSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      CompanyAction.getListPagesSuccess({
        loading: false,
        data: {},
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchCompanyList({ payload }) {
  yield put(
    CompanyAction.getListSuccess({
      loading: true,
      data: [],
    })
  )
  try {
    let { data } = yield call(CompanyAPI.getCompanyList)
    yield put(
      CompanyAction.getListSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      CompanyAction.getListSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchPostCompany({ payload, action }) {
  yield put(
    CompanyAction.postDataSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(CompanyAPI.postData, payload)
    action()
  } catch (error) {
    yield put(
      CompanyAction.postDataSuccess({
        loading: false,
        data: {},
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchDetailCompany({ payload, action }) {
  yield put(
    CompanyAction.getDetailSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(CompanyAPI.getDetail, payload.id)
    action(data)
  } catch (error) {
    yield put(
      CompanyAction.getDetailSuccess({
        loading: false,
        data: {},
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchPutCompany({ payload, action }) {
  yield put(
    CompanyAction.putDataSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(CompanyAPI.putData, payload)
    action()
  } catch (error) {
    yield put(
      CompanyAction.putDataSuccess({
        loading: false,
        data: {},
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* companySaga() {
  yield takeEvery(CompanyTypes.GET_COMPANY_PAGES, fetchCompanyListOnPage)
  yield takeEvery(CompanyTypes.GET_COMPANY_LIST, fetchCompanyList)
  yield takeEvery(CompanyTypes.POST_COMPANY, fetchPostCompany)
  yield takeEvery(CompanyTypes.GET_DETAIL_COMPANY_BY_ID, fetchDetailCompany)
  yield takeEvery(CompanyTypes.PUT_COMPANY, fetchPutCompany)
}

export default companySaga
